import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    answers: [],
    results: [],
    points: 0,
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  },
});
